'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lbe_doeraene_webcomponents_ui5_configkeys_TitleLevel$H2$() {
}
export { $c_Lbe_doeraene_webcomponents_ui5_configkeys_TitleLevel$H2$ as $c_Lbe_doeraene_webcomponents_ui5_configkeys_TitleLevel$H2$ };
$p = $c_Lbe_doeraene_webcomponents_ui5_configkeys_TitleLevel$H2$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lbe_doeraene_webcomponents_ui5_configkeys_TitleLevel$H2$;
/** @constructor */
function $h_Lbe_doeraene_webcomponents_ui5_configkeys_TitleLevel$H2$() {
}
export { $h_Lbe_doeraene_webcomponents_ui5_configkeys_TitleLevel$H2$ as $h_Lbe_doeraene_webcomponents_ui5_configkeys_TitleLevel$H2$ };
$h_Lbe_doeraene_webcomponents_ui5_configkeys_TitleLevel$H2$.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return 2282;
});
$p.b = (function() {
  return "H2";
});
$p.n = (function() {
  return 0;
});
$p.o = (function() {
  return "H2";
});
$p.g = (function(n) {
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.y = (function(p) {
  return this;
});
var $d_Lbe_doeraene_webcomponents_ui5_configkeys_TitleLevel$H2$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lbe_doeraene_webcomponents_ui5_configkeys_TitleLevel$H2$, "be.doeraene.webcomponents.ui5.configkeys.TitleLevel$H2$", ({
  gE: 1,
  b9: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Lbe_doeraene_webcomponents_ui5_configkeys_TitleLevel$H2$ as $d_Lbe_doeraene_webcomponents_ui5_configkeys_TitleLevel$H2$ };
var $n_Lbe_doeraene_webcomponents_ui5_configkeys_TitleLevel$H2$;
function $m_Lbe_doeraene_webcomponents_ui5_configkeys_TitleLevel$H2$() {
  if ((!$n_Lbe_doeraene_webcomponents_ui5_configkeys_TitleLevel$H2$)) {
    $n_Lbe_doeraene_webcomponents_ui5_configkeys_TitleLevel$H2$ = new $c_Lbe_doeraene_webcomponents_ui5_configkeys_TitleLevel$H2$();
  }
  return $n_Lbe_doeraene_webcomponents_ui5_configkeys_TitleLevel$H2$;
}
export { $m_Lbe_doeraene_webcomponents_ui5_configkeys_TitleLevel$H2$ as $m_Lbe_doeraene_webcomponents_ui5_configkeys_TitleLevel$H2$ };
